import React, { useState, useEffect } from 'react'
import { 
  Spinner, 
  Input, 
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Slider,
  Checkbox
} from '@material-tailwind/react'
import { useTranslation } from 'react-i18next';
import { getAlkanesBalance, getAlkanesAddressOutput, getPaymentUtxosAlkanesMerge, getAlkanesKey } from '../../util/alkanes-api';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { v4 as uuidv4 } from 'uuid';
import { formatNumberWithCommas } from '../../util/format-data';
import AlkanesIndexer from '../../components/Indexer/AlkanesIndexer';
import alkanesImg from '../../assets/imgs/alkanes.png';
import cheekyImg from '../../assets/imgs/cheeky.png';
import { useSelector } from 'react-redux';
import FeeRateCard from '../../components/FeeRateCard';
import FeeRateCardNew from '../../components/FeeRateCardNew';
import { alkanesServiceAddress } from '../../configs/constant';
import { BitcoinNetworkType, signMessage, signTransaction, sendBtcTransaction } from 'sats-connect';
import { useWallet, useWallets } from '@wallet-standard/react';

import toast, { Toaster } from 'react-hot-toast';

export default function ExplorerAlkanes() {
  const wallet = useSelector(state => state.wallet);
  const feeRates = useSelector(state => state.feeRate);

  const { wallets } = useWallets();

  const SatsConnectNamespace = 'sats-connect:';

  const isSatsConnectCompatibleWallet = (wallet) => {
      return SatsConnectNamespace in wallet.features;
  }
  
  const [loading, setLoading] = useState(false);
  const feeRateTabs = ["Slow", "Normal", "Fast", "Custom"];
  const [feeRateMode, setFeeRateMode] = useState("Normal");
  const [feerate, setFeerate] = useState(0);
  const [feeValues, setFeeValues] = useState({
    "inscribeFee": 0,
    "networkFee": 0,
    "serviceFee": 0,
    "referFee": 0,
    "totalFee": 0
  });
  const [customFee, setCustomFee] = useState(0);
  const [sliderValue, setSliderValue] = useState(2);
  const [address, setAddress] = useState('');
  const [balances, setBalances] = useState([]);
  const [showMerge, setShowMerge] = useState(false);
  const [receiveAddress, setReceiveAddress] = useState('');
  const [selectedUtxos, setSelectedUtxos] = useState([]);
  const [selectedBalanceAmount, setSelectedBalanceAmount] = useState(0);
  const [selectedAll, setSelectedAll] = useState(false);
  const [serviceFee, setServiceFee] = useState(1500);
  const [showMergeLoading, setShowMergeLoading] = useState(false);
  const [mergeError, setMergeError] = useState("");
  const [detailedBalance, setDetailedBalance] = useState({});

  const { t, i18n } = useTranslation();

  useEffect(() => {
    let intervalId;

    const updateFees = async () => {
      try {
        if (feeRateMode == "Custom") {
          setFeerate(customFee);
        }
        else
        {
          setFeerate(feeRates[feeRateMode]);
          if (customFee == 0) 
          {
            setCustomFee(feeRates["Fast"] + 1);
          }
        }
      }
      catch (e) {
        console.log(e);
      }
    }
    updateFees();
    intervalId = setInterval(updateFees, 20 * 1000);
    return () => {
      clearInterval(intervalId);
    }
  }, [feeRateMode, customFee])

  useEffect(() => {
    if (wallet.nostrOrdinalsAddress != null && wallet.nostrOrdinalsAddress != "") {
      setAddress(wallet.nostrOrdinalsAddress);
      setReceiveAddress(wallet.nostrOrdinalsAddress);
      handleSearch(wallet.nostrOrdinalsAddress);
    }
  }, [wallet.nostrOrdinalsAddress]);

  const onChange = (e) => {
    setAddress(e.target.value);
    setBalances([]);
  }

  const handleSearch = async (address) => {
    if (!address) {
      return;
    }

    setLoading(true);

    const response = await getAlkanesAddressOutput(address);

    setBalances(response);
    setLoading(false);
  }

  const handleMerge = async (balance) => {
    if (wallet.nostrOrdinalsAddress == null || wallet.nostrOrdinalsAddress == "") {
      toast.error(t('Please connect your wallet.'));
      return;
    }

    setShowMerge(true);
    setDetailedBalance(balance);
    setSelectedUtxos(0);
    setSelectedBalanceAmount(0);
  }

  const handleSelectUtxo = (index) => {
    const newUtxos = [...detailedBalance.data];
    if (newUtxos[index].selected) {
      newUtxos[index].selected = false;
    }
    else
    {
      newUtxos[index].selected = true;
    }
    setDetailedBalance({...detailedBalance, data: newUtxos});
    setSelectedBalanceAmount(newUtxos.reduce((acc, utxo) => utxo.selected ? acc + utxo.balance : acc, 0));
  }

  const handleSelectAll = () => {
    const newUtxos = [...detailedBalance.data];
    newUtxos.forEach(utxo => {
      utxo.selected = !selectedAll;
    });
    setDetailedBalance({...detailedBalance, data: newUtxos});
    setSelectedAll(!selectedAll);
    setSelectedBalanceAmount(newUtxos.reduce((acc, utxo) => utxo.selected ? acc + utxo.balance : acc, 0));
  }

  const handleConfirmMerge = async () => {
    setShowMergeLoading(true);
    if (wallet.nostrOrdinalsAddress == "")
    {
      setMergeError(t('Connect Wallet Error Message'));
      setShowMergeLoading(false);
      return;
    }

    if (receiveAddress == "") {
      setMergeError(t('Insert Receive Address Error Message'));
      setShowMergeLoading(false);
      return;
    }

    if (selectedBalanceAmount == 0) {
      setMergeError(t('Select Utxos Error Message'));
      setShowMergeLoading(false);
      return;
    }

    const selectedUtxos = detailedBalance.data.filter(utxo => utxo.selected);
    let runesResult = await getAlkanesKey(detailedBalance.height, detailedBalance.txindex);

    let tempfeerate = parseFloat(feerate);
        
    if (wallet.domain == "xverseWallet") tempfeerate = Math.ceil(feerate * 1.2);

    if (tempfeerate == null || tempfeerate == undefined || isNaN(tempfeerate)) {
      tempfeerate = 1.1;
    }

    const params = {
      paymentAddress: wallet.nostrPaymentAddress,
      mergeUtxos: selectedUtxos,
      fundingAddress: alkanesServiceAddress,
      fundingAmount: serviceFee,
      paymentPubkey: wallet.paymentPublicKey,
      feeRate: tempfeerate,
      provider: wallet.domain, 
      receiveAddress, 
      key: runesResult.mergeKey
    }

    const paymentUtxos = await getPaymentUtxosAlkanesMerge(params);

    if (paymentUtxos.status == "fail") {
      alert(t('Insufficient Balance Error Message'));
      setShowMergeLoading(false);
      return;
    }

    try{
      if (wallet.domain == "oyl") {
        const txid = await window.oyl.signPsbt({ 
          psbt: paymentUtxos.hex,  
          broadcast: true
        })
      }
      else if (wallet.domain == "tapwallet") {
        const signedPsbt = await window.tapwallet.signPsbt(paymentUtxos.psbt);
        const txid = await window.tapwallet.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "unisat") {
        const signedPsbt = await window.unisat.signPsbt(paymentUtxos.psbt);
        const txid = await window.unisat.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "okxwallet") {
        const signedPsbt = await window.okxwallet.bitcoin.signPsbt(paymentUtxos.psbt);
        const txid = await window.okxwallet.bitcoin.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "xverseWallet") {
        let res = paymentUtxos;
        if (res.status == "success") {
          let signIndexes = [];
          for(let i=0;i<res.count; i++){
            signIndexes.push(i);
          }

          await signTransaction({
            payload: {
                network: {
                    type: BitcoinNetworkType.Mainnet,
                },
                psbtBase64: res.psbt,
                broadcast: true,
                message: "tip the author! Don't worry this will not be broadcasted.",
                inputsToSign: [
                    {
                        address: wallet.nostrPaymentAddress,
                        signingIndexes: signIndexes,
                    },
                ],
            },
            onFinish: async (response) => {
            },
            onCancel: async () => {
                alert(t('Request canceled'));
                setShowMergeLoading(false);
            },
          });
  
        }
        else {
          alert(t('Insufficient Balance Error Message'));
          setShowMergeLoading(false);
          return;
        }
      }
      else if (wallet.domain == "magiceden") {
        let res = paymentUtxos;
        if (res.status == "success") {
          let signIndexes = [];
          for(let i=0;i<res.count; i++){
            signIndexes.push(i);
          }

          let magicedenWallets = wallets.filter(isSatsConnectCompatibleWallet);

          await signTransaction({
            getProvider: async () =>
              magicedenWallets[0].features['sats-connect:'].provider,
            payload: {
                network: {
                    type: BitcoinNetworkType.Mainnet,
                },
                psbtBase64: res.psbt,
                broadcast: true,
                message: "tip the author! Don't worry this will not be broadcasted.",
                inputsToSign: [
                    {
                        address: wallet.nostrPaymentAddress,
                        signingIndexes: signIndexes,
                    },
                ],
            },
            onFinish: async (response) => {   
            },
            onCancel: async () => {
                alert(t('Request canceled'));
                setShowMergeLoading(false);
            },
          });
  
        }
        else {
          alert(t('Insufficient Balance Error Message'));
          setShowMergeLoading(false);
          return;
        }
      }
      else {
        toast.error("This wallet does not support yet. Please wait!");
        setShowMergeLoading(false);
        setShowMerge(false);
        return;
      }
    }
    catch(e)
    {
      console.log(e);
      alert(t('User Reject Request Error Message'));
      setShowMergeLoading(false);
      return;
    }

    toast.success(t('Merge Success Message'));
    setShowMerge(false);
    setShowMergeLoading(false);
  }

  const handleCustomFee = (value) => {
    const sanitizedValue = value.replace(/[^0-9.]/g, '');
    setCustomFee(sanitizedValue);
  }

  return (
    <div className="text-white mt-[65px] max-w-[1500px] w-full md:px-7 px-2 flex flex-col items-center mb-10 min-h-[600px]">
      {
        loading ? <Spinner className="h-16 w-16 text-gray-900/50 fixed top-[50%] left-[50%]" color="pink"/> : <></>
      }
      <div className="flex flex-row justify-center gap-1 items-center w-full mt-10">
        <img src={alkanesImg} className="w-[50px] h-[50px] rounded-full"/>
        <div className=" text-primary sm:text-3xl text-2xl font-bold text-center">
          {t('Checkout Alkanes balance of any address')}
        </div>
        <img src={cheekyImg} className="w-[50px] h-[50px] rounded-full"/>
      </div>
      
      <div className="relative flex w-full max-w-[50rem] mt-5">
        <Input
          type="text"
          label={t('Address')}
          value={address}
          onChange={onChange}
          className="pr-20"
          color="white"
        />
        <div className="!absolute right-1 top-1 rounded px-3 py-1 text-white bg-primary hover:bg-primary-hover cursor-pointer" onClick={() => {handleSearch(address)}}>{t('Search')}</div>
      </div>
      {
        address == "" ?
        <AlkanesIndexer/>
        : 
        <div className="grid 2xl:grid-cols-6 xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 grid-cols-2 gap-3 w-full mt-8">
        {
          balances.length > 0 ?
            balances.map((balance, index) => {
              return (
                <div key={uuidv4()} className="bg-background2 border-solid border-[1px] border-gray-600 rounded-md p-3 flex flex-col gap-1 justify-center items-center">
                  <div className="text-primary text-lg font-bold">{balance.name}</div>
                  <div className="text-white text-lg font-bold">({balance.height}:{balance.txindex})</div>
                  <div className="text-white text-lg font-bold">{formatNumberWithCommas(balance.totalBalance)}</div>
                  {
                    address == wallet.nostrOrdinalsAddress ?
                    <div className="text-white bg-primary rounded-md px-2 py-1 cursor-pointer mt-1 w-full text-center" onClick={() => {handleMerge(balance)}}>{t('Merge')}</div>
                    :
                    <></>
                  }
                </div>
              )
            }) 
            : 
            address != "" ?
            <div className="text-white text-lg font-bold">{t('No Alkanes balance.')}</div>
            : 
            <></>
        }
        </div>
      }
      <Dialog
        open={showMerge}
        size={"md"}
        className="bg-black border-gray-900 border-[1px]"
      >
        <DialogHeader>
          <div className="flex flex-row justify-between items-center w-full relative">
            <div className="text-white sm:text-2xl text-xl font-bold text-center w-full mt-1">{t('Merge')} Alkanes</div>
            <div className="absolute right-0 top-0 cursor-pointer">
              <XMarkIcon className="w-6 h-6 text-white" onClick={() => {setShowMerge(false)}}/>
            </div>
          </div>
        </DialogHeader>
        <DialogBody>
          { showMerge ?
            <div className="flex flex-col sm:gap-3 gap-2 w-full">
              <div className="text-white sm:text-md text-sm font-bold w-full">
                Alkanes {t('Name')}: {detailedBalance.name}
              </div>
              <div className="text-white sm:text-md text-sm font-bold w-full">
                Alkanes {t('ID')}: {detailedBalance.height}:{detailedBalance.txindex}
              </div>
              <div className="text-white sm:text-md text-sm font-bold w-full">
                Alkanes {t('Balance')}: {formatNumberWithCommas(detailedBalance.totalBalance)}
              </div>
              <div className="sm:text-md text-sm text-white">
                {t('Select Network Fee You Want')}:
              </div>
              <div className="grid grid-cols-3 gap-3">
                <FeeRateCardNew header={feeRateTabs[1]} rate={feeRates[feeRateTabs[1]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[1])}}/>
                <FeeRateCardNew header={feeRateTabs[2]} rate={feeRates[feeRateTabs[2]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[2])}}/>
                <FeeRateCardNew header={feeRateTabs[3]} rate={customFee} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[3])}}/>
              </div>
              {
                feeRateMode == "Custom" ? 
                <div className="flex flex-row gap-3 items-center">
                  <Slider className="sm:flex hidden" color="blue" value = {sliderValue} onChange = {(e) => setSliderValue(e.target.value)}/>
                  <div className="sm:max-w-[200px] w-full">
                    <Input type="text" color="white" label = {t('Custom Fee')} className="sm:max-w-[200px] w-full" value={customFee} onChange = {(e) => {handleCustomFee(e.target.value)}}/>
                  </div>
                </div>
                : 
                <></>
              }
              <div className="flex flex-col gap-2 w-full">
                <Input type="text" color="white" label = {t('Receive Address')} className="w-full" value={receiveAddress} onChange = {(e) => {setReceiveAddress(e.target.value)}}/>
              </div>
              <div className="flex flex-col gap-1 w-full">
                <div className="flex flex-row justify-between items-center">
                  <div className="text-white sm:text-md text-sm font-bold w-full">
                    {t('Select Utxos')} ({formatNumberWithCommas(selectedBalanceAmount)})
                  </div>
                  <div className="flex flex-row items-center">
                    <Checkbox checked={selectedAll} onClick={() => {handleSelectAll()}}/>
                    <div className="text-white sm:text-md text-sm font-bold">{t('ALL')}</div>
                  </div>
                </div>
                <div className="border-[1px] border-solid border-gray-600 rounded-md p-3 max-h-[200px] overflow-y-auto">
                  <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-3">
                    {
                      detailedBalance.data.map((utxo, index) => {
                        return (
                          <div key={uuidv4()} className="flex flex-row gap-1 items-center cursor-pointer" onClick={() => {handleSelectUtxo(index)}} >
                            <Checkbox checked={utxo.selected}/>
                            <div className="text-white sm:text-md text-sm font-bold">
                              {formatNumberWithCommas(utxo.balance)}
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
                </div>
              </div>
              {
                mergeError != "" ?
                <div className="text-red-500 text-sm font-bold">{mergeError}</div>
                :
                <></>
              }
              <div className="text-white sm:text-md text-sm font-bold">{t('Service Fee')}: {formatNumberWithCommas(serviceFee)} sats</div>
              {
                showMergeLoading ?
                <div className="flex flex-row justify-center items-center w-full">
                  <Spinner className="h-12 w-12 text-primary"/>
                </div>
                :
                <div className="text-white bg-primary rounded-md px-4 w-full font-bold py-1 cursor-pointer mt-1 text-center" onClick={() => {handleConfirmMerge()}}>{t('Merge')}</div>
              }
            </div>
            :
            <div className="flex flex-row justify-center items-center w-full">
              <Spinner className="h-12 w-12 text-primary"/>
            </div>
          }
        </DialogBody>
      </Dialog>
    </div>
  )
}
